import * as Api from '@ViewModels';

export const availableExternalIntegrationsWithIndustries = [
	{ provider: Api.IntegrationProvider.PracticePanther, industry: Api.Industry.Legal },
	{ provider: Api.IntegrationProvider.MyCase, industry: Api.Industry.Legal },
	{ provider: Api.IntegrationProvider.Eclipse, industry: Api.Industry.Insurance },
	{ provider: Api.IntegrationProvider.Clio, industry: Api.Industry.Legal },
	{ provider: Api.IntegrationProvider.ServiceTitan, industry: Api.Industry.HomeMaintenance },
	{ provider: Api.IntegrationProvider.HousecallPro, industry: Api.Industry.HomeMaintenance },
	{ provider: Api.IntegrationProvider.Wealthbox, industry: Api.Industry.Financial },
	{ provider: Api.IntegrationProvider.Redtail, industry: Api.Industry.Financial },
	{ provider: Api.IntegrationProvider.Bloomerang, industry: Api.Industry.NonProfit },
	{ provider: Api.IntegrationProvider.DonorPerfect, industry: Api.Industry.NonProfit },
	{ provider: Api.IntegrationProvider.CasePeer, industry: Api.Industry.Legal },
	{ provider: Api.IntegrationProvider.MedicarePro, industry: Api.Industry.Insurance },
];

export const alwaysAvailableExternalIntegrations = [
	{ provider: Api.IntegrationProvider.MicrosoftDynamics365Sales },
	{ provider: Api.IntegrationProvider.Salesforce },
	{ provider: Api.IntegrationProvider.QuickBooksOnline },
];

/** Hidden from admins without OnlyForDevelopers; customers still see them once enabled. */
export const developerOnlyExternalIntegrations: Api.IntegrationProvider[] = [Api.IntegrationProvider.MedicarePro];

export const isDeveloperOnlyIntegration = (provider: Api.IntegrationProvider) =>
	developerOnlyExternalIntegrations.includes(provider);
